// IE 2026 10 15 / ODOO-5800 (ЗП-№5, P4; Igor 15.10, DESIGN §10 пп. 3, 3.1): блок PLAN APPROVAL формы ячейки у строк документов планов Баланса
// (PURCHASE-PLAN / DISTR-PLAN / SALES-PLAN / MANUF-PLAN; контракт PR #243: статус шапки — каталог STATUS-plan, плоский блок цепочки {stage, manager, head,
// approved_through}, «дата до» approved_until, несколько документов одного ключа) — ступень согласования (autoplan / manager / head / approved), ответственный,
// срок, approved through / until, версия, список документов ключа в месяце (статус STATUS-plan, ступень, «дата до», количество), замок правки по ступени
// (или «Edit the plan in the document: …» при нескольких документах / строках) и действие «Approve until date» (метод бэка plan_docs_approve_until —
// переход approve единицы текущей ступени с «датой до»). Данные — cell_passport.plan_doc бэка (common_modules/plan_docs_balance.passport_block).
// Чистая логика без Vue / DOM — юнит-тесты tests/unit/cellPlanDoc.test.mjs. Флаг fe.ux.planDocsRows (дефолт ВКЛ); выкл — блока и кнопки нет, замки строк
// (isReadOnly бэка) действуют как прежде.

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === null || v === undefined) ? '' : String(v)
const STAGE_ICON = { autoplan: '⚡', manager: '✎', head: '◎', approved: '✓' }
const STAGE_TITLE = { autoplan: 'Auto-planned', manager: 'Manager', head: 'Head', approved: 'Approved' }

export function cellPlanDoc_on(setting) {
    try { return typeof setting === 'function' ? setting('fe.ux.planDocsRows', true) !== false : true } catch (e) { return true }
}

// запись документа ключа (cell_passport.plan_doc.docs[]) → строка списка блока
export function cellPlanDoc_doc(raw, t = (s) => s) {
    if (!isObj(raw) || !str(raw.id)) return null
    const stage = str(raw.stage) || 'manager'
    return {
        id: str(raw.id), title: str(raw.title) || str(raw.id), segment: str(raw.segment), status: str(raw.status), statusTitle: str(raw.status_title) || str(raw.status),
        stage, stageIcon: str(raw.stage_icon) || STAGE_ICON[stage] || '·', stageTitle: str(raw.stage_title) || t(STAGE_TITLE[stage] || stage),
        approvedUntil: str(raw.approved_until).slice(0, 10), approvedThrough: str(raw.approved_through).slice(0, 10), responsibleText: str(raw.responsible_text),
        due: str(raw.due).slice(0, 10), rows: Number(raw.rows) || 0, quantity: (raw.quantity === null || raw.quantity === undefined || raw.quantity === '') ? null : Number(raw.quantity),
        sync: raw.sync === true, link: isObj(raw.link) ? { segment: str(raw.link.segment), id: str(raw.link.id) } : { segment: str(raw.segment), id: str(raw.id) },
    }
}

// ответ бэка cell_passport.plan_doc → модель блока; null — не строка плана / документа нет
export function cellPlanDoc_model(raw, t = (s) => s) {
    if (!isObj(raw) || !str(raw.id)) return null
    const stage = str(raw.stage) || 'manager'
    const resp = isObj(raw.responsible) ? raw.responsible : null
    const actions = Array.isArray(raw.actions) ? raw.actions.map(str) : []
    const docs = (Array.isArray(raw.docs) ? raw.docs : []).map((d) => cellPlanDoc_doc(d, t)).filter(Boolean)
    const m = {
        segment: str(raw.segment), id: str(raw.id), title: str(raw.title), version: str(raw.version), versionTitle: str(raw.version_title) || str(raw.version),
        status: str(raw.status), statusTitle: str(raw.status_title) || str(raw.status), stage, stageIcon: str(raw.stage_icon) || STAGE_ICON[stage] || '·', stageTitle: str(raw.stage_title) || t(STAGE_TITLE[stage] || stage),
        level: str(raw.level), unit: str(raw.unit), responsible: resp ? { id: str(resp.user), name: str(resp.name) || str(resp.user) } : null,
        responsibleText: str(raw.responsible_text) || (resp ? (str(resp.name) || str(resp.user)) : ''), due: str(raw.due).slice(0, 10),
        approvedThrough: str(raw.approved_through).slice(0, 10), approvedUntil: str(raw.approved_until).slice(0, 10),
        measure: str(raw.measure), editable: raw.editable === true, canEdit: raw.can_edit === true, lockReason: str(raw.lock_reason), multi: str(raw.multi),
        canApprove: actions.includes('approve_until'), link: isObj(raw.link) ? { segment: str(raw.link.segment), id: str(raw.link.id) } : { segment: str(raw.segment), id: str(raw.id) },
        syncedAt: str(raw.synced_at), sourceDocs: Number(raw.source_docs) || 0, month: str(raw.month).slice(0, 7),
        docs, docsCount: Number(raw.docs_count) || docs.length,
    }
    m.summary = cellPlanDoc_summary(m, t)
    return m
}

// сводка свёрнутого блока: «◎ Head · Olena H. · due 2026-10-20 · Transfer · 2026-10-01 · 2 documents»; замок — « · locked»
export function cellPlanDoc_summary(m, t = (s) => s) {
    if (!isObj(m)) return ''
    const parts = [m.stageIcon + ' ' + m.stageTitle]
    if (m.responsibleText) parts.push(m.responsibleText)
    if (m.due) parts.push(t('due {date}', { date: m.due }))
    if (m.approvedUntil) parts.push(t('approved until {date}', { date: m.approvedUntil }))
    if (m.versionTitle) parts.push(m.versionTitle)
    if (m.docsCount > 1) parts.push(t('{n} documents', { n: m.docsCount }))
    if (m.editable && !m.canEdit) parts.push(t('locked'))
    return parts.join(' · ')
}

export function cellPlanDoc_validDate(s) {
    const v = str(s).trim()
    if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false
    const d = new Date(v + 'T00:00:00Z')
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v
}

// действие «Approve until date» → описание кнопки для store.executeStoreMethod (executeWidgetMethod plan_docs_approve_until); null — нельзя (нет права / дата не YYYY-MM-DD)
export function cellPlanDoc_action(m, date, ctx = {}) {
    if (!isObj(m) || !m.canApprove || !m.id) return null
    const d = str(date).trim()
    if (d && !cellPlanDoc_validDate(d)) return null
    const a = { name: 'button-plan-docs-approve-until', attr_type: 'AttrButton', title: 'Approve until date', cssClass: 'pi p-button-white pi-verified',
        command: 'executeWidgetMethod', method: 'plan_docs_approve_until', record_sendToBackend_exclude: ['_doc'], uiHelp: 'planDocs.approveUntil',
        params: { plan_doc_id: m.id, segment: m.segment, date: d } }
    if (str(ctx.source_name)) a.source_name = ctx.source_name
    if (str(ctx.binding)) a.binding = ctx.binding
    return a
}

// подсказка замка ячейки строки плана (AttrGrid: причина отказа ввода) — текст бэка как есть (ступень либо «Edit the plan in the document: …»), иначе по ступени
export function cellPlanDoc_lockText(m, t = (s) => s) {
    if (!isObj(m)) return ''
    if (m.lockReason) return m.lockReason
    if (!m.editable) return t('Calculated row of the plan document (read-only); edit the Plan row')
    return ''
}

// подпись документа в списке блока: «Human PP · Approved ✓ · ≤ 2026-11-30 · 40»
export function cellPlanDoc_docText(d, t = (s) => s, fmt = (n) => String(n)) {
    if (!isObj(d)) return ''
    const parts = [d.title, d.statusTitle + ' ' + d.stageIcon]
    if (d.approvedUntil) parts.push('≤ ' + d.approvedUntil)
    if (d.quantity !== null && d.quantity !== undefined) parts.push(fmt(d.quantity))
    if (d.sync) parts.push(t('built by calculation'))
    return parts.join(' · ')
}
